import React from "react";
import { FileStatus } from "@quantizr-engineering/common/types/file";
import Loader from "./Loader";

interface FilePollStatusRowProps {
  status: FileStatus | undefined | string;
}

const FilePollStatusRow = React.memo<FilePollStatusRowProps>(({ status }) => {
  const getStatusClassName = (status: FileStatus | undefined | string) => {
    switch (status) {
      case FileStatus.PROCESSED:
        return "bg-green-100 text-green-800";
      case FileStatus.PROCESSING:
        return "bg-yellow-100 text-yellow-800";
      case FileStatus.PENDING:
        return "bg-gray-100 text-gray-800";
      case FileStatus.ERROR || "ERROR":
        return "bg-red-100 text-red-800";
      case "Re-processing duplicate upload":
        return "bg-purple-100 text-purple-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <td className="px-6 py-4 whitespace-nowrap flex flex-row">
      <span
        className={`flex items-center px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusClassName(
          status
        )}`}
      >
        {status}
      </span>
      {(status === "Uploading" ||
        status === FileStatus.PROCESSING ||
        status === "Re-processing duplicate upload") && <Loader />}
    </td>
  );
});

export default FilePollStatusRow;
